import React from "react";

export default function MailboxTable({ mailboxes, onEdit, onDelete, onSendEmail }) {
  if (!mailboxes.length) return <p className="admin-empty-state">No mailboxes found.</p>;

  return (
    <div className="admin-table-wrap">
      <table className="admin-table admin-mailbox-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Tenant Name</th>
            <th>Tenant Email</th>
            <th>Has Mail</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {mailboxes.map((mb) => (
            <tr key={mb.id}>
              <td>{mb.number}</td>
              <td>{mb.tenant?.name || "-"}</td>
              <td>{mb.tenant?.email || "-"}</td>
              <td>
                <span className={`admin-status ${mb.hasMail ? "admin-status-success" : "admin-status-muted"}`}>
                  {mb.hasMail ? "Yes" : "No"}
                </span>
              </td>
              <td>
                <div className="admin-row-actions">
                  <button className="admin-button admin-button-secondary" type="button" onClick={() => onEdit(mb)}>
                    Edit
                  </button>
                  <button className="admin-button admin-button-primary" type="button" onClick={() => onSendEmail(mb.id)}>
                    Send Email
                  </button>
                  <button
                    className="admin-button admin-button-danger"
                    type="button"
                    onClick={() => {
                      if (window.confirm("Delete this mailbox?")) onDelete(mb.id);
                    }}
                  >
                    Delete
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
